import script from "./NavbarMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavbarMenu.vue?vue&type=script&setup=true&lang=ts"

import "./NavbarMenu.vue?vue&type=style&index=0&id=22667841&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22667841"]])

export default __exports__